import React, { useEffect, useState } from "react";
import HeroSection from "./HeroSection";
import { ProfileDetails } from "./ProfileDetails";
import { SearchForm } from "./SearchForm";
import CategoriesSection from "./CategoriesSection";
import ExampleSection from "./ExampleSection";
import { BrandsSection } from "./BrandsSection";
import FAQ from "./FAQ";
import AppFooter from "./AppFooter";
import { BrandWork } from "./BrandWork";
import { storageHandler } from "../../Helpers/storage";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import { fraudDetectionTools } from "../../Services/fraudDetectionTools.service";
import { Toast } from "../../Components";
import { parseInput } from "../../Components/Constants/AppConstant";

const multiSelectOptions = "";
const categoriesData = [
  {
    name: "Fashion",
    img_url: "https://assets.tamayou.com/web/corp-categories/fashion.jpeg",
    cta: "https://app.tamayou.com/#/influencerdiscovery?c=777",
  },
  {
    name: "Fitness",
    img_url: "https://assets.tamayou.com/web/corp-categories/fitness.jpeg",
    cta: "https://app.tamayou.com/#/influencerdiscovery?c=635",
  },

  {
    name: "Beauty",
    img_url: "https://assets.tamayou.com/web/corp-categories/beauty.jpeg",
    cta: "https://app.tamayou.com/#/influencerdiscovery?c=778",
  },

  {
    name: "Travel",
    img_url: "https://assets.tamayou.com/web/corp-categories/travel.jpeg",
    cta: "https://app.tamayou.com/#/influencerdiscovery?c=888",
  },
];

const exampleSearchContent = {
  tag: "Search",
  title: "Find and Hire Influencers in Seconds on the Marketplace",
  steps: [
    {
      title: "Search Influencers",
      description:
        "Search thousands of vetted Instagram, TikTok, and YouTube influencers.",
    },
    {
      title: "Purchase & Chat Securely",
      description:
        "Safely purchase and communicate through Collabstr. We hold your payment until the work is completed.",
    },
    {
      title: "Receive Quality Content",
      description:
        "Receive your high-quality content from influencers directly through the platform.",
    },
  ],
  image: {
    src: "https://betacorp.tamayou.com/images/corp_mkt_1.png",
    srcSet: "https://betacorp.tamayou.com/images/corp_mkt_1.png",
    alt: "Influencer marketplace",
  },
};

export const exampleTrackingContent = {
  tag: "Track",
  title: "Track Post Analytics and Performance in Real Time",
  steps: [
    {
      title: "One-Click Tracking",
      description:
        "Track Instagram, TikTok, and YouTube content in real time from a single dashboard. Say goodbye to manual tracking and messy spreadsheets.",
    },
    {
      title: "Advanced Analytics & Reporting",
      description:
        "Analyze content performance over time, including impressions, engagement and more. Organize performance by campaign and effortlessly build reports.",
    },
    {
      title: "Fully Automated",
      description:
        "Metrics are updated every 24 hours, ensuring performance data is always up-to-date.",
    },
  ],
  image: {
    src: "https://betacorp.tamayou.com/images/corp_mkt_3.png",
    srcSet: "https://betacorp.tamayou.com/images/corp_mkt_3.png",
    alt: "Influencer campaign brief",
  },
};

const exampleCampaignContent = {
  tag: "Campaigns",
  title: "Post Campaigns and Have 250,000+ Influencers Come to You",
  steps: [
    {
      title: "Set Targeting",
      description:
        "Specify demographics including niche, location and following size of the influencers you want to target.",
    },
    {
      title: "Post Campaign",
      description:
        "Centralize your images, requirements, and more in a campaign brief sent to 250,000 influencers.",
    },
    {
      title: "Influencers Apply",
      description:
        "Targeted influencers submit their pricing, and you choose who to collaborate with.",
    },
  ],
  image: {
    src: "https://betacorp.tamayou.com/images/corp_mkt_5.png",
    srcSet: "https://betacorp.tamayou.com/images/corp_mkt_5.png",
    alt: "Influencer campaign brief",
  },
};

export const faqForLanding = [
  {
    question: "What is a fake follower?",
    answer:
      "A fake follower is an account that lacks genuine engagement and interest in your content. Also known as bots or spam accounts, fake followers are often artificially created, either through automated processes or purchased, with the primary goal of inflating follower count and engagement metrics. Using a reliable fake follower checker, like this one, helps unveil these deceptive accounts and ensures a more authentic and engaged follower base.",
  },
  {
    question: "How do you spot a fake follower?",
    answer: `Spotting a fake follower involves observing an accounts engagement patterns, posts, followings and more. Use a dedicated fake follower checker tool that assesses metrics such as likes, comments, and post frequency. Signs of a fake follower include a low engagement rate, generic or low comments, and irregular activity. By employing an effective fake follower checker, you can accurately identify and remove these bot and spam accounts.

Fake followers typically have one or more of the following characteristics:
1. Zero followers: They usually have no or very low followers.
2. 0-10 posts: Fake followers will have zero or a very low number of posts, they will also have irregular posting activity.
3. No profile picture: Fake followers typically don't use images in their profile pictures, if they do, it will be AI generated or stock images.
4. Following a lot of accounts: While their following is zero or very low, a fake follower will usually follow a large number of other accounts. Usually above 1,000
5. Random letters and numbers in username: You will typically notice that their username is a random selection of letters and/or numbers and looks spammy.`,
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
  {
    question: "What are fake followers on Instagram?",
    answer:
      "Checking for fake followers on your Instagram profile is crucial to ensure the authenticity and effectiveness of your online presence. Fake followers can significantly distort your engagement rates, mislead your influencer marketing efforts, and dilute your overall social media performance. Identifying and understanding your fake follower breakdown through a reliable fake follower check allows you to make informed decisions and foster a genuine connection with your authentic audience. Plus, Collabstr's fake follower checker is free!",
  },
];

export const FraudDetectionTools = ({
  cartItem,
  closeCartPanel,
  setSaveCampaign,
  setAuth,
  setModalSwitch,
  NotifModul,
  profiles,
  user,
  setModalNotification,
  locationData,
  setShowConfirmModal,
  setShowConfirmAction,
  saveCampaign,
  goToPricing,
  setModal,
}) => {
  const [platform] = useState("ig");
  const [input, setInput] = useState("");
  const [profileData, setProfileData] = useState({});
  const [toastList, setToastList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const addToast = (data) => {
    try {
      const newToastList = [...toastList];
      newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
      setToastList(newToastList);
    } catch (err) {
      console.error("Toast error:", err);
    }
  };

  const handleSearch = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const cleanData = input.startsWith("@") ? input.slice(1) : input;
      const res = await fraudDetectionTools.getData(platform, cleanData);
      if (res.success) {
        setProfileData(res?.data);
      }
    } catch (err) {
      console.log("API Error:", err);
      if (err.apiResponseStatus != 404) {
        let error = parseInput(err.message);
        addToast({
          error: true,
          msg: error.message,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    } finally {
      setIsLoading(false);
      setInput("");
    }
  };

  let data = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      data = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }
  useEffect(() => {
    data.p_f_ids.includes(3);
  }, []);

  return (
    <>
      {data.p_f_ids.includes(3) ? (
        <>
          <div className="mx-auto w-full max-w-7xl 2xl:max-w-[90rem] p-6">
            <HeroSection />
            <div className="max-w-[90%] mx-auto">
              <SearchForm
                multiSelectOptions={multiSelectOptions}
                setInput={setInput}
                handleSearch={handleSearch}
                input={input}
                isLoading={isLoading}
              />
            </div>
            <ProfileDetails profileData={profileData} />
            {/* <CategoriesSection categories={categoriesData} />
            <div id="marketplace-section" className="py-8">
              <ExampleSection content={exampleSearchContent} />
            </div>
            <ExampleSection content={exampleCampaignContent} reverse />
            <ExampleSection content={exampleTrackingContent} />
            <BrandWork />
            <BrandsSection />
            <div id="faq-section" className="py-8">
              <FAQ faqData={faqForLanding} />
            </div>
            <AppFooter /> */}
          </div>
          {toastList && <Toast list={toastList} setList={setToastList} />}
        </>
      ) : (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Direct Campaigns"}
            background={"background_inflist.png"}
          ></NotSubscribe>
        </>
      )}
    </>
  );
};
